import React from 'react';
import BLComponent from '../../core/_BLComponent.jsx';

export default class CategoryTreeView extends BLComponent {
    constructor(props, context) {
        super(props, context);	// This should come first. 
    }

    componentDidUpdate() {
        //this.resizeSideBar();
    }
    componentDidMount() {
        //this.resizeSideBar();
        //this.sidebar.style.height 	= (availableHeight > visibleHeight ? visibleHeight : availableHeight) + 'px';
    }

    resizeSideBar() {
        const padding = 12;
        const footer 					= document.getElementById('bl-footer');
        const listBody 					= document.getElementById('personal-inventory-list-content');
        const main                      = document.getElementById('main-content');
        this.sidebar.style.height       = "100px"; // need this to caculate height accurate .
        const expectedHeight = footer.offsetTop - listBody.offsetTop - main.offsetTop;
        this.sidebar.style.height = expectedHeight + (padding*2) + 'px';

    }

    render() {
        return (
            <div ref={sidebar => this.sidebar = sidebar} className="personal-inventory__grid-cols-cell-category l-border personal-inventory__section-category-tree">
                <div  style={{maxHeight:"20px"}}>
                    <div className="l-margin-left l-pad-y--l personal-inventory__section-category-tree-title"><strong>Filter by category</strong></div>
                    {this.renderCategoryList()}
                </div>
            </div>
        );
    }

    renderCategoryList() {
        const {listCategory} = this.props.data;
        const listCategoryView = this.getCategoryListView(listCategory);

        if ( listCategoryView == null ) {
            return null;
        }
        
        return (
            <div className="personal-inventory__section-category-tree-list">{listCategoryView}</div>
        )

    }

    getCategoryListView(listCategory) {
        if ( ( typeof listCategory == "undefined") || (listCategory.length == 0) ) {
            return null;
        }
    
        const listCategoryView = listCategory.map((category, idx) => {
            const catName = blapp.util.decodeHtml(category.catName);
            return(
                <li key={"categoryListView-" + idx} onClick={()=>this.props.func.toggleCategory(category.idCategory, category.selected)} className={ "l-pad-x " + ((category.selected)?"personal-inventory__section-category-tree-list-item-selected":"")}>
                    <div className="l-flex l-split l-cursor-pointer">
                        <div>{catName} ({category.itemCnt})</div>
                        {
                            category.selected && <div><i className="fa-solid fa-check text--bold personal-inventory__section-category-tree-list-item-selected-icon"/></div>
                        }
                    </div>
                </li>

            )
        });

        return (
            <ul>{listCategoryView}</ul>
        )
    }

}
